"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeVisibilityCallback = exports.removeStickyElement = exports.removeScrollCallback = exports.isElementInViewport = exports.getStickyElementsHeight = exports.getStickyElements = exports.addVisibilityCallback = exports.addStickyElement = exports.addScrollCallback = exports.Visibility = void 0;
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _RegisterEventHandler = require("./RegisterEventHandler");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Visibility;
exports.Visibility = Visibility;
(function (Visibility) {
  Visibility[Visibility["FULLY_VISIBLE"] = 0] = "FULLY_VISIBLE";
  Visibility[Visibility["TOP_CLIPPED"] = 1] = "TOP_CLIPPED";
  Visibility[Visibility["BOTTOM_CLIPPED"] = 2] = "BOTTOM_CLIPPED";
})(Visibility || (exports.Visibility = Visibility = {}));
var scrollCallbacks = [];
var visibilityCallbacks = [];
var stickyElements = [];
var stickyElementsHeight = 0;
var eventHandler;
var tryRegisterHandler = function tryRegisterHandler() {
  eventHandler = eventHandler || (0, _RegisterEventHandler.registerEventHandler)("scroll", runCallbacks);
};
var tryUnregisterHandler = function tryUnregisterHandler() {
  if (!visibilityCallbacks.length && !scrollCallbacks.length && eventHandler) {
    eventHandler.unsubscribe();
    eventHandler = undefined;
  }
};
/**
 * registers a callback function for a scroll event
 * After registering, the callback function(s) are executed
 */
var addScrollCallback = function addScrollCallback(callback) {
  tryRegisterHandler();
  scrollCallbacks.push(callback);
  runCallbacks();
};
/**
 * registers a callback function for a visiblility CHANGE event
 * -> i.e. if one or more DOM elements (elementIdsToWatch) move in or out of the Viewport.
 * Visibility is the kind of visiblility (top, bottom, fully visible)
 * You can move the visibility to the top or buttom by a number of pixels by using the offset parameter
 * After registering, the callback function(s) are executed.
 *      -> If the elementId(s) is/are visible in the first place, the visibilityCallback will run with "visible=true"
 *      -> So if a Media component (autoplay=true) is visible in the Viewport in the first place, the video will run.
 */
exports.addScrollCallback = addScrollCallback;
var addVisibilityCallback = function addVisibilityCallback(callback, elementIdsToWatch, visibility, offset) {
  tryRegisterHandler();
  visibilityCallbacks.push({
    callback: callback,
    elementIdsToWatch: elementIdsToWatch,
    visibility: visibility,
    offset: offset,
    lastResult: undefined
  });
  runCallbacks();
};
exports.addVisibilityCallback = addVisibilityCallback;
var addStickyElement = function addStickyElement(name, elm) {
  tryRegisterHandler();
  stickyElements.push({
    name: name,
    elm: elm
  });
  stickyElementsHeight += elm.offsetHeight;
  runCallbacks();
};
exports.addStickyElement = addStickyElement;
var getStickyElements = function getStickyElements() {
  return stickyElements;
};
exports.getStickyElements = getStickyElements;
var getStickyElementsHeight = function getStickyElementsHeight() {
  return stickyElementsHeight;
};
exports.getStickyElementsHeight = getStickyElementsHeight;
var removeStickyElement = function removeStickyElement(name) {
  stickyElements = stickyElements.filter(function (curr) {
    if (curr.name === name) {
      stickyElementsHeight -= curr.elm.offsetHeight;
    }
    return curr.name !== name;
  });
  tryUnregisterHandler();
};
exports.removeStickyElement = removeStickyElement;
var removeScrollCallback = function removeScrollCallback(callback) {
  scrollCallbacks = scrollCallbacks.filter(function (c) {
    return c !== callback;
  });
  tryUnregisterHandler();
};
exports.removeScrollCallback = removeScrollCallback;
var removeVisibilityCallback = function removeVisibilityCallback(callback) {
  visibilityCallbacks = visibilityCallbacks.filter(function (c) {
    return c.callback !== callback;
  });
  tryUnregisterHandler();
};
exports.removeVisibilityCallback = removeVisibilityCallback;
var runCallbacks = function runCallbacks() {
  if (eventHandler) {
    eventHandler.unsetRunning();
  }
  visibilityCallbacks.forEach(function (callbackObject) {
    var callback = callbackObject.callback,
      elementIdsToWatch = callbackObject.elementIdsToWatch,
      offset = callbackObject.offset,
      lastResult = callbackObject.lastResult,
      visibility = callbackObject.visibility;
    if (!elementIdsToWatch) {
      callback();
    } else {
      var result = isElementInViewport(elementIdsToWatch, visibility, offset);
      if (!(0, _isEqual["default"])(result, lastResult)) {
        callbackObject.lastResult = result;
        callback(result);
      }
    }
  });
  scrollCallbacks.forEach(function (callback) {
    return callback();
  });
};
/**
 * this function takes in an array of elementIds. Those DOM elements that fulfill the Visibility
 * criterion (Visibility is an enum see above) are returned in an array.
 * You can move the visibility to the top or buttom by a number of pixels by using the offset parameter
 */
var isElementInViewport = function isElementInViewport(elementIds, visibility) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var result = elementIds.reduce(function (acc, id) {
    var target = document.getElementById(id);
    if (!target) {
      return acc;
    }
    var stickyElementsHeight = stickyElements.reduce(function (res, curr) {
      return res + curr.elm.offsetHeight;
    }, 0);
    var offsetTopUpperEdge = target.getBoundingClientRect().top - offset - stickyElementsHeight;
    var offsetBottomUpperEdge = target.getBoundingClientRect().bottom - offset - stickyElementsHeight;
    var offsetTopLowerEdge = target.getBoundingClientRect().top - window.innerHeight;
    var offsetBottomLowerEdge = target.getBoundingClientRect().bottom - window.innerHeight;
    if (visibility === Visibility.TOP_CLIPPED) {
      var isInTarget = offsetTopUpperEdge < 0 && offsetBottomUpperEdge > 0;
      var isAbove = offsetTopUpperEdge < 0 && offsetBottomUpperEdge < 0;
      var isBelow = offsetTopUpperEdge > 0 && offsetBottomUpperEdge > 0;
      if (isInTarget) {
        acc.targetIds.push(id);
      } else if (isAbove) {
        acc.idsAbove.push(id);
      } else if (isBelow) {
        acc.idsBelow.push(id);
      }
    } else if (visibility === Visibility.BOTTOM_CLIPPED) {
      var _isInTarget = offsetTopLowerEdge < 0 && offsetBottomLowerEdge > 0;
      var _isAbove = offsetTopLowerEdge < 0 && offsetBottomLowerEdge < 0;
      var _isBelow = offsetTopLowerEdge > 0 && offsetBottomLowerEdge > 0;
      if (_isInTarget) {
        acc.targetIds.push(id);
      } else if (_isAbove) {
        acc.idsAbove.push(id);
      } else if (_isBelow) {
        acc.idsBelow.push(id);
      }
    } else if (offsetTopUpperEdge > 0 && offsetBottomLowerEdge < 0) {
      acc.targetIds.push(id);
    }
    // return ;
    return acc;
  }, {
    targetIds: [],
    idsAbove: [],
    idsBelow: []
  });
  if (result.targetIds.length > 0) {
    return result.targetIds;
  }
  if (result.idsAbove.length > 0 && result.idsBelow.length > 0) {
    return [result.idsAbove[result.idsAbove.length - 1]];
  }
  return [];
};
exports.isElementInViewport = isElementInViewport;